<template>
    <div class="departure-item">
        <div class="item-box">
            <!-- <el-checkbox v-model="checkAll" class="check-all" :style="{ '--fill-color': '#00a9ac' }" :disabled="disabled"
                @change="handleCheckAllChange">全选</el-checkbox> -->
            <div v-for="(item, index) in orderListData"
                 :key="index"
                 class="departure-content">
                <div class="title">
                    <div>
                        <el-checkbox class="el-cbox"
                                     :style="{ '--fill-color': item.color }"
                                     @change="val => handleSingleChecked(val, index, item)"
                                     :disabled="item.disabled"
                                     v-model="item.checked"></el-checkbox>
                        <span @click="copyText(item.dispatchNo)"
                              class="cpNo">{{ item.dispatchNo }}</span>
                        <i class="el-icon-view"
                           @click="handleDetails(item)"></i>
                    </div>
                    <div class="status">{{ statusType[item.dispatchStatus] }}</div>
                </div>
                <div class="line">

                    <span><b>{{ item.lineName }}</b></span>
                    <div v-if="+item.dispatchStatus <= 30">
                        <el-button size="mini"
                                   @click="handlePlatoon(item)">{{ item.dispatchStatus == "6" ? "排车" :
                            "编辑" }}</el-button>
                    </div>
                </div>
                <div class="info">
                    <div>{{ item.dispatchStatus == '6' ? "规划里程" : "计费里程" }}:<span>{{ item.totalMileage || 0 }} Km</span>
                    </div>
                    <div>订单数:<span>{{ item.taskCount || 0 }}</span></div>
                    <div>重量:<span>{{ item.totalGrossWeight || 0 }} Kg</span></div>
                    <div>体积:<span>{{ item.volume || 0 }} m³</span></div>
                    <div>司机:<span>{{ item.driver || '*' }}</span></div>
                    <div>车牌:<span>{{ item.vehicleCard }}</span></div>
                </div>
            </div>
        </div>
        <departdetails-dialog @resetData="resetListData"
                              :obj=obj
                              :appointmentSiteCodeWhiteList="appointmentSiteCodeWhiteList"
                              ref="showFlag"
                              v-bind="$attrs"></departdetails-dialog>
        <car-scheduling-dialog ref="AdmittRuleForm"
                               :RwCarVisiable.sync="RwCarVisiable"
                               v-if="RwCarVisiable"
                               :label-position="labelPosition"
                               :carrierDisabled="true"
                               :taskDataList="taskDataList"
                               @handleRwCarClose="handleRwCarClose"
                               @AdmittOk="AdmittOk"
                               :dataLists="dataObj">
        </car-scheduling-dialog>
    </div>
</template>
<script>
import departdetailsDialog from '../dialog/DpartDetailsDialog';
import carSchedulingDialog from '../../../../components/dialog/carSchedulingDialog';
import { getTaskList, getDispathOrderPreservation } from '../../../../api/visualMapLayout';
import { dictWithUrl } from '@/components/lots/api.js';
export default {
    name: 'departure-list',
    components: { departdetailsDialog, carSchedulingDialog },
    props: {
        orderListData: {
            type: Array,
            default: () => []
        },
        totalOrderListData: {
            type: Array,
            default: () => []
        },
        appointmentSiteCodeWhiteList: {
            type: Array,
            default: () => []
        },
    },
    data () {
        return {
            showFlag: false,
            RwCarVisiable: false,
            dataObj: {},
            taskDataList: [],
            labelPosition: 'right',
            statusType: {},
            dispatchNo: '',
            version: '',
            obj: {},
            checkAll: false,
            disabled: false

        };
    },
    methods: {
        // 引入字典处理字段
        async getDictList () {
            if (Object.keys(this.statusType).length > 0) return;
            const res = await dictWithUrl('MAP_DISPATCH_STATUS');
            if (res && +res.code === 0) {
                const { MAP_DISPATCH_STATUS } = res.data;
                this.statusType = MAP_DISPATCH_STATUS;
            }
        },
        selDisabledStatus () {
            if (this.selectedCount === 20) {
                this.$message.warning('最多只能规划20条线路，超过20条则无法选中');
                const checkedFalse = this.totalOrderListData.filter(v => v.checked === false);
                checkedFalse.forEach((i) => {
                    i.disabled = true;
                });
                this.disabled = true;
            } else {
                const hasTrueValue = this.totalOrderListData.some(item => item.disabled === true);
                if (hasTrueValue) {
                    this.totalOrderListData.forEach((v) => {
                        v.disabled = false;
                    });
                    this.disabled = false;
                }
            }
        },
        // 发车单号复制
        copyText (copyText) {
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`发车单号 ‘${input.value}’ 复制成功`);
        },
        handleCheckAllChange (val, index) {
            this.$emit('allSelect', val, index, this.orderListData, this.totalOrderListData);
            this.selDisabledStatus();
        },
        handleSingleChecked (val, index, item) {
            this.selDisabledStatus();
            const data = [item];
            this.$emit('on-click', val, index, data, this.totalOrderListData);
        },
        handleRwCarClose () { this.RwCarVisiable = false; },
        handleDetails (item) {
            const { dispatchNo } = item;
            this.obj = item;
            this.$refs.showFlag.show();
            this.$refs.showFlag.getData(dispatchNo);
        },
        async handlePlatoon (v) {
            await getTaskList({ dispatchNo: v.dispatchNo }).then((res) => {
                if (res && +res.code === 0) {
                    this.taskDataList = res.data.data;
                }
            });
            this.dataObj = v;
            if (+v.dispatchStatus === 6) {
                this.dataObj.carrierCode = this.taskDataList[0].carrierCode
                this.dataObj.carrierName = this.taskDataList[0].carrierName
                this.dataObj.procurementChannel = this.taskDataList[0].procurementChannel
                this.dataObj.transUnitName = this.taskDataList[0].transUnitName
                this.dataObj.paymentTerms = this.taskDataList[0].paymentTerms
                this.dataObj.transportContractNo = this.taskDataList[0].transportContractNo
                this.dataObj.vehicleCard = ''
            }
            this.dispatchNo = v.dispatchNo;
            this.version = v.version;
            this.RwCarVisiable = true;
            this.$nextTick(() => {
                this.$refs.AdmittRuleForm.AdmittRuleForm.routeNoList =
                    v.lineCodes;
            });
        },
        isPlatoonMsg(res) {
            if (res && res.data && typeof res.data === 'string' && res.data.includes('该正向发车单有退货入库单')) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    showClose: true,
                    message: `<div>
                                    <span style="white-space: pre-line;">发车单号：${res.data}</span>
                                </div>`,
                    type: 'success',
                    duration: 5000
                });
                return false;
            }
            return true;
        },
        AdmittOk (formName) {
            const version = this.version;
            const dispatchNo = this.dispatchNo;
            formName.data['dispatchNo'] = dispatchNo;
            formName.data['version'] = version;
            formName.data['operateEntrance']='LSP'
            if (formName.state === true) {
                this.$refs.AdmittRuleForm.saveLoading = true;
                getDispathOrderPreservation(formName.data, this.dispatchNo, this.version).then(res => {
                    if (res && +res.code === 0) {
                        this.$refs.AdmittRuleForm.saveLoading = false;
                        this.isPlatoonMsg() && this.$message({
                            showClose: true,
                            type: 'success',
                            duration: 3000,
                            message: '保存成功'
                        });
                        this.$emit('resetData');
                        this.RwCarVisiable = false;
                    } else {
                        this.$refs.AdmittRuleForm.saveLoading = false;
                    }
                }).catch(() => {
                    this.$message('保存失败');
                    this.$refs.AdmittRuleForm.saveLoading = false;
                    this.RwCarVisiable = false;
                });
            } else {
                return false;
            }
        },
        checkAllTure () {
            this.checkAll = true;
        },
        checkAllFalse () {
            this.checkAll = false;
        },
        // 刷新发车单列表
        resetListData () {
            this.$emit('resetData');
        }

    },
    computed: {
        selectedCount: function () {
            const count = this.totalOrderListData.reduce((acc, item) => {
                if (item.checked === true) {
                    return acc + 1;
                } else {
                    return acc;
                }
            }, 0);
            return count;
        }
    },
   watch: {
        orderListData: {
            handler (val) {
                this.getDictList(); // 获取字典数据
            },
            deep: true,
            immediate: true
        }

    },

};
</script>
<style lang="less" scoped>
.departure-item {
    padding: 10px;

    .item-box {
        padding: 10px;
        height: 50vh;
        overflow: auto;

        .check-all {
            margin-bottom: 5px;
        }

        .departure-content {
            background: #ffffff;
            box-shadow: 0px -1px 0px 0px #e9eaec;

            .title {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                padding-top: 12px;

                .el-cbox {
                    margin-right: 5px;
                }

                // 修改选中背景颜色
                ::v-deep .el-checkbox {
                    .el-checkbox__label {
                        color: var(--fill-color);
                    }

                    .el-checkbox__input.is-checked .el-checkbox__inner,
                    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                        background-color: var(--fill-color);
                        border-color: var(--fill-color);
                    }

                    .el-checkbox__input.is-focus .el-checkbox__inner,
                    .el-checkbox__inner:hover {
                        border-color: var(--fill-color);
                    }

                    .el-checkbox__input.is-focus .el-checkbox__inner,
                    .el-checkbox__inner {
                        border-color: var(--fill-color);
                    }
                }

                .cpNo {
                    color: #5f6578;
                    font-size: 13px;
                    font-weight: regular;
                    margin-right: 6px;
                    cursor: pointer;
                }

                .checkbox-background {
                    position: absolute;
                    left: 0;
                    width: 16px;
                    height: 16px;
                    border-radius: 4px;
                }

                .el-icon-view {
                    color: #00bcbf;
                    font-size: 20px;
                    cursor: pointer;
                    vertical-align: middle;
                }

                .status {
                    font-size: 14px;
                    font-weight: regular;
                }
            }

            .line {
                display: flex;
                justify-content: space-between;
                padding: 5px 0;
                color: #00a9ac;
                font-size: 16px;
            }

            .info {
                display: flex;
                flex-wrap: wrap;
                padding: 5px;
                border-radius: 4px;
                background: #f9f9f9;

                div {
                    color: #8c919c;
                    font-size: 13px;
                    width: 33.3%;
                    padding-bottom: 5px;

                    span {
                        color: #333333;
                    }
                }
            }
        }
    }
}
</style>
